// hooks/useSegmentIdentify.ts
import { useQuery } from "@tanstack/react-query";
import { AnalyticsUtils } from "@/shared/utils/AnalyticsUtils";
import { Quote } from "../types/Quote.interface";

interface IdentifyParams {
    email?: string;
    postalCode?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
}

const extractIdentifyParams = (quote: Quote): IdentifyParams => ({
    email: quote.email,
    postalCode: quote.ratingAddress?.zipCode,
    firstName: quote.firstName,
    lastName: quote.lastName,
    phone: quote.phone
});

export const useSegmentIdentify = (quote?: Quote) => {
    const identifyParams = quote ? extractIdentifyParams(quote) : null;

    return useQuery({
        queryKey: ["segmentIdentify", identifyParams],
        queryFn: async () => {
            if (!quote) return null;

            try {
                await AnalyticsUtils.identifyUser(quote);
                return true;
            } catch (error) {
                console.error("Error identifying user:", error);
                throw error;
            }
        },
        enabled: !!identifyParams && typeof window !== "undefined" && !!quote?.email,
        retry: false,
        staleTime: Infinity,
        refetchOnWindowFocus: false
    });
};
